import React from 'react';
import PropTypes from 'prop-types';
import { DropboxChooser } from '../../DropboxChooser';

const { REACT_APP_DROPBOX_KEY } = process.env;

const ConnectFiles = ({ onSelectResources }) => (
  <div className="row p-3">
    <div className="col-12">
      <a className="d-flex flex-row no-decoration">
        <DropboxChooser
          appKey={REACT_APP_DROPBOX_KEY}
          className="dropbox_custom_class"
          folderselect
          multiselect
          openOnClick
          onSuccess={onSelectResources}
        >
          <span className="text-dark-teal text-uppercase t-14 align-self-center">
            <button className="dropbox-button">+</button> CONNECT TO DROPBOX
          </span>
        </DropboxChooser>
      </a>
    </div>
  </div>
);

ConnectFiles.propTypes = {
  onSelectResources: PropTypes.func.isRequired,
};

export default ConnectFiles;



// WEBPACK FOOTER //
// ./src/components/ProjectView/ConnectFiles/ConnectFiles.js